import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import PoliceReportWorkQLoading, { PoliceReportListSkeleton } from "./PoliceReportWorkQLoading";
import { useSelector } from "react-redux";
import classes from '../WorkQComponent.module.css'
import policeClasses from './PoliceReportWorkQ.module.css'
import ListLink from "./policeReport/ListLink";
import MismatchedDataDetails from "./mismatched/MismatchedDataDetails";
import Pagination from '../pagination/Pagination'

export default function MismatchedDataWorkQ({loading, patientsList, workqSlug}) {
    const navigate = useNavigate();
    const {patientId} = useParams()
    const [listIsLoaded, setListIsLoaded] = useState(false)
    const showDetailsPanel = Boolean(patientId) || listIsLoaded

    const showListSkeleton = useSelector((state) => {
        if (!state.filter.loading) return false
        if (state.filter.snapshotData) return false
        return state.filter.currentpagedata == null
    })

    useEffect(() => {
        if (patientsList && patientsList.links && patientsList.links.first?.includes('mismatched')) { //check for 'police-report slug in links to make sure this si the  right list, and only then navigate to details

            setListIsLoaded(true)

            if (patientsList.data.length > 0) {
                if (!patientId) {
                    const firstWithPersonNumber = patientsList.data.find(item => item?.patient?.person_number)
                    const targetId = firstWithPersonNumber?.patient?.person_number ?? patientsList.data[0]?.case?.id
                    if (targetId) {
                        navigate(`./${targetId}`, {replace: true});
                    }
                } else {
                    // navigate(`/work-queues/police-report/${patientsList.data[0]?.case?.id}`, {replace: true});
                    navigate(`/work-queues/drivers-license-mismatch/${patientId}`, {replace: true});
                }
            } 
            
            
        }
    }, [patientsList, patientId, loading])

    if (showListSkeleton && !patientId) {
        return <PoliceReportWorkQLoading showDetails={false} />
    }

    if (showListSkeleton && patientId) {
        return (
            <div className={classes.police_report_main}>
                <PoliceReportListSkeleton />
                <MismatchedDataDetails data={patientsList?.data} />
            </div>
        )
    }

    return <>
        {(patientsList || patientId) && <>
            <div className={classes.police_report_main}>
                <div className={classes.police_report_list}>
                    {patientsList?.data && patientsList.data.map(item => (
                        <div key={item.case?.id} className={policeClasses.list_item}>
                            <ListLink classes={policeClasses} item={item}/>
                        </div>
                    ))}
                    {patientsList && patientsList.data.length == 0 && <div className={policeClasses.list_item_empty}>No patients found</div>}
                </div>
                {showDetailsPanel && <>
                    {patientsList && patientsList.data.length == 0 && !patientId
                        ? <div className={policeClasses.details_list_item_empty}>No patients found</div>
                        : <MismatchedDataDetails data={patientsList?.data}/>}
                </>}
            </div>

            {patientsList?.meta && <div className={classes.pagination_container}>
                <Pagination data={patientsList} apiType={workqSlug} />
            </div>}
        </>}
    </>
}